<template>
    <BasePage :loading="loading" :error="error" :params="params" style="overflow: hidden">
        <SotHeader v-show="params.back_button_visible !== '0'" :label="title" />
        <!--<div v-show="!allowStartTask" class="q-pa-md">Завершите все предыдущие задания перед тем как перейти к новому</div>-->
        <div v-if="task" class="q-pa-md base-page-content">
            <div class="q-gutter-y-lg" style="margin-bottom: 0">
                <div v-if="youtubeVideoUrl || preloadingVideo" style="width: 100%;">
                    <div v-show="preloadingVideo" class="flex flex-center full-height">
                        <q-circular-progress indeterminate size="sm" color="primary" />
                    </div>
                    <q-video
                        v-if="youtubeVideoUrl"
                        :src="youtubeVideoUrl"
                        style="border-radius: 12px"
                        :ratio="16/9"
                    />
                </div>
                <div v-show="task.pretask_image_url">
                    <q-img :src="task.pretask_image_url" fit="cover" style="border-radius: 12px;" />
                </div>
                <div v-show="redirectsLoading" class="flex flex-center">
                    <q-circular-progress indeterminate color="primary" size="sm" />
                </div>
                <!--
                <iframe ref="video" width="558" height="315" src="//video.platformcraft.ru/embed/62a7bb5cef3db5381909909e" frameBorder="0" scrolling="no" allowFullScreen></iframe>
                -->
                <div v-html="pretask_text" />
                <div v-html="description" />
                <div v-show="params.show_final_text === '1'" class="text-weight-bold">
                    {{ params.final_text }}
                </div>
                <div v-show="params.operator_answer">
                    <div>Сообщение организатора: {{ params.operator_answer }}</div>
                </div>
                <!--<div v-show="params.show_final_text !== '1' || params.is_skipped === '1'" class="column q-gutter-y-sm" style="padding-bottom: 16px;">-->
                <div class="column q-gutter-y-sm" style="padding-bottom: 16px;">
                    <div v-show="task.description && params.show_final_text === '1' && !params.final_positive && allowRetakeTask" class="row" style="padding-top: 15px; ">
                        <DefaultButton label="Пересдать" class="col" @click="start" />
                    </div>
                    <div class="col row">
                        <DefaultButton v-show="task.description" label="Далее" class="col" @click="start" />
                    </div>
                    <div class="col row">
                        <DefaultButton v-show="task.description && params.is_skipped !== '1' && params.show_final_text !== '1'" label="Пропустить" class="col" @click="skip" :loading="skipping" />
                    </div>
                    <div v-show="!task.description" class="col">По этой теме нет теста</div>
                </div>
            </div>
        </div>
    </BasePage>
</template>

<script>
import BasePage from 'pages/BasePage';
import { api } from 'boot/axios';
import SotHeader from 'components/ui/design/SotHeader';
import DefaultButton from 'components/ui/common/DefaultButton';

const extractUrls = require('extract-urls');

export default {
    name: 'PageTask',
    components: { DefaultButton, SotHeader, BasePage },
    props: {
        params: {
            type: Object,
            default: undefined,
        },
    },
    data () {
        return {
            allowStartTask: true,
            loading: false,
            error: undefined,
            task: undefined,
            youtubeVideoUrl: undefined,
            pretask_text: undefined,
            description: undefined,
            redirectsLoading: false,
            allowRetakeTask: false,
            preloadingVideo: false,
            skippping: false,
        };
    },
    computed: {
        taskId () {
            return this.params.task_id;
        },
        title () {
            const { title } = this.params;
            if (!title && this.task) {
                return this.task.title;
            }
            return title;
        },
        user () {
            return this.$store.state.pages.user;
        },
    },
    watch: {
        user () {
            this.$nextTick(() => {
                this.load();
            });
        },
    },
    mounted () {
        this.load();
    },
    methods: {
        load () {
            if (!this.user) { return; }
            this.skipping = false;
            this.loading = true;
            this.pretask_text = undefined;
            this.description = undefined;
            this.$db.tasks.getTask(this.taskId).then(async (task) => {
                this.task = task;
                /*
                if (!task.description) {
                    this.allowStartTask = true;
                } else {
                    this.allowStartTask = await this.checkPrevTasksCompleted();
                }
                */
                this.allowStartTask = true;
                // this.redirectsLoading = true;

                /*
                if (task.pretask_text && task.pretask_text.includes('youtube')) {
                    this.preloadingVideo = true;
                }
                if (task.description && task.description.includes('youtube')) {
                    this.preloadingVideo = true;
                }
                */
                this.description = task.description;
                this.pretask_text = task.pretask_text;
                // this.makeLinks(task.pretask_text, 'pretask_text');
                // this.makeLinks(task.description, 'description');

                const s = task.pretask_image_url;
                if (s && (s.endsWith('.mov') || s.endsWith('.mp4'))) {
                    this.youtubeVideoUrl = task.pretask_image_url;
                    this.preloadingVideo = false;
                    task.pretask_image_url = '';
                }

                this.loading = false;
                this.checkAllowRetakeTask();
                if (this.allowStartTask) {
                    this.checkAutostartTask();
                }
            });
            /*
            // revert
            setTimeout(() => {
                const { video } = this.$refs;
                console.log('video:', video);
                // console.log('video.contentDocument:', video.contentWindow.document.getElementById('video_html5_api'));
                // Uncaught DOMException: Permission denied to access property "document" on cross-origin object
                const frameDoc = video.contentDocument || video.contentWindow.document;
                console.log('frameDoc:', frameDoc);
            }, 2000);
            */
        },
        async checkPrevTasksCompleted () {
            if (this.params.show_all_tasks) {
                return true;
            }
            // Проверить - если до этой задачи есть невыполненные - то не разрешать выполнение текущей
            const { user } = this.$store.state.pages;
            const { task } = this;
            const tasks = await this.$db.tasks.getUncompletedTasks(task.num, user.chat_id);
            return tasks.length < 2;
        },
        start () {
            const { user } = this.$store.state.pages;
            if (!user) {
                this.$q.notify('Для выполнения темы требуется авторизация');
                return;
            }
            if (this.$q.platform.is.desktop) {
                this.$router.push({ name: 'quiz', query: { taskId: this.task.id } });
            } else {
                this.$pages.push({ to: 'quiz', params: { task: this.task }, quiz_done_button_visible: this.params.quiz_done_button_visible });
            }
        },
        async makeLinks (text, tag) {
            text = await this.extractYoutubeVideo(text);
            const exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig;
            const text1 = text.replace(exp, "<a href='$1'>$1</a>");
            const exp2 = /(^|[^/])(www\.[\S]+(\b|$))/gim;
            text = text1.replace(exp2, '$1<a target="_blank" href="https://$2">$2</a>');
            text = text.replaceAll('\n', '<br/>');
            if (tag === 'pretask_text') {
                this.pretask_text = text;
            } else {
                this.description = text;
            }
        },
        checkAutostartTask () {
            if (this.params.auto_start === '1') {
                this.$nextTick(() => {
                    this.$pages.push({
                        to: 'quiz', params: { task: this.task }, quiz_done_button_visible: this.params.quiz_done_button_visible, auto_start: '1',
                    });
                });
            }
        },
        async extractYoutubeVideo (text) {
            // TODO: - технический долг
            // вынести это в отдельный класс парсеров
            const urls = extractUrls(text);

            this.youtubeVideoUrl = undefined;
            if (urls && urls.length > 0) {
                for (let index = 0; index < urls.length; index += 1) {
                    let url = urls[index];
                    // eslint-disable-next-line no-continue
                    if (!url) { continue; }
                    // eslint-disable-next-line no-continue
                    if (this.youtubeVideoUrl) { continue; }

                    // text = text.replace(url, '');
                    let finalUrl;

                    const i = url.indexOf('\n');
                    if (i > 0) {
                        url = url.slice(0, i);
                    }

                    const data = new FormData();
                    data.append('url', url);
                    // eslint-disable-next-line no-await-in-loop,no-loop-func
                    await api.post('bypass_url.php', data).then((r) => {
                        finalUrl = r.data.url;
                        if (finalUrl && !this.youtubeVideoUrl) {
                            if (finalUrl.includes('youtube.com')) {
                                finalUrl = this.trimUrl(finalUrl);

                                if (finalUrl.includes('embed')) {
                                    this.youtubeVideoUrl = finalUrl;
                                } else {
                                    this.youtubeVideoUrl = this.makeYoutubeVideoEmbed(finalUrl);
                                }
                                this.preloadingVideo = false;
                                this.redirectsLoading = false;
                                text = text.replace(url, '');
                                /*
                                const matchesFull = text.match(/(\(https?:\/\/[^ ]*)/);
                                if (matchesFull && matchesFull.length > 0) {
                                    text = text.replaceAll(matchesFull[0], '');
                                    return text;
                                }
                                 */
                            }
                        }
                    });
                }
            } else {
                this.redirectsLoading = false;
            }
            // this.preloadingVideo = false;
            return text;
        },
        makeYoutubeVideoEmbed (url) {
            // https://www.youtube.com/watch?v=4kHnM8ZT8qE&t=5s
            url = url.replaceAll('https://www.youtube.com/watch?', '');
            const urlParams = new URLSearchParams(url);
            const videoKey = urlParams.get('v');
            let timeStart = urlParams.get('t') || '0';
            timeStart = timeStart.replace('.', '');
            timeStart = timeStart.replace('s', '');
            url = `https://www.youtube.com/embed/${videoKey}?autoplay=0&fs=1&start=${timeStart}`;
            return url;
        },
        checkAllowRetakeTask () {
            this.allowRetakeTask = true;
            /*
            const { user } = this.$store.state.pages;
            const { task } = this;
            if (!task) { return; }

            // Если после прохождения задания прошел один день и более - то тогда показать кнопку "Пересдать"
            this.$db.tasks.getTaskCompleted(task.id, user.chat_id).then((r) => {
                if (r) {
                    const d = moment(r.created_at);
                    const diffDays = moment().diff(d, 'day');
                    this.allowRetakeTask = diffDays >= 1;
                }
            });
            */
        },
        trimUrl (url) {
            // вырезать точки, запятые, вокслиц знак, вопрос, точка с запятой, разные кавычки, закрывающаяся скобка
            const chars = ['.', ',', '!', '?', ';', '"', '`', '\'', ')'];
            for (let i = 0; i < chars.length; i += 1) {
                const c = chars[i];
                if (url.slice(-1) === c) {
                    url = url.slice(0, -1);
                }
            }
            return url;
        },
        skip () {
            const { user } = this.$store.state.pages;
            const { task } = this;
            this.skippping = true;
            this.$db.tasks.skipTask(task.id, user.chat_id).then(() => {
                this.skippping = false;
                this.$pages.back();
                if (this.$q.platform.is.desktop) {
                    this.$router.back();
                }
            });
        },
    },
};
</script>

<style scoped>

</style>
